export default {
  REACT_APP_ORDERBOOK_CONTRACT: 'orai1nt58gcu4e63v7k55phnr3gaym9tvk3q4apqzqccjuwppgjuyjy6sxk8yzp',
  REACT_APP_BASE_API_URL: 'https://orderbook-backend.oraidex.io',
  REACT_APP_WS_URL: 'wss://orderbook-backend.oraidex.io/websocket',
  REACT_APP_SENTRY_ENVIRONMENT: 'production'
};
